import { createContext } from 'react'
import config from '../../config'

export const StorageContext = createContext({
	...config.defaultStorageValues,
});